import React, { useState } from 'react'
import { ordersApi } from '../../../shared/api/orders'

const OrderCreatePage: React.FC = () => {
  const [runnerId, setRunnerId] = useState('')
  const [eventId, setEventId] = useState('')
  const [companionId, setCompanionId] = useState('')
  const [targetTime, setTargetTime] = useState('')
  const [price, setPrice] = useState('')
  const [msg, setMsg] = useState('')

  const submit = async () => {
    setMsg('')
    try {
      const orderData: any = {
        runner_id: Number(runnerId),
        event_id: Number(eventId),
        price: Number(price),
      }
      if (companionId) orderData.companion_id = Number(companionId)
      if (targetTime) orderData.target_time = targetTime
      
      const res = await ordersApi.create(orderData)
      setMsg(`创建成功，订单ID：${res.id}`)
    } catch (e: any) {
      setMsg(e?.message || '创建失败')
    }
  }

  return (
    <div className="p-4">
      <h1 className="text-xl font-semibold mb-4">创建订单（调试）</h1>
      <div className="grid gap-2 max-w-md">
        <input placeholder="runner_id" value={runnerId} onChange={e => setRunnerId(e.target.value)} className="border p-2" />
        <input placeholder="event_id" value={eventId} onChange={e => setEventId(e.target.value)} className="border p-2" />
        <input placeholder="companion_id(可选)" value={companionId} onChange={e => setCompanionId(e.target.value)} className="border p-2" />
        <input placeholder="target_time(可选，如 3h30)" value={targetTime} onChange={e => setTargetTime(e.target.value)} className="border p-2" />
        <input placeholder="price" value={price} onChange={e => setPrice(e.target.value)} className="border p-2" />
        <button onClick={submit} className="bg-orange-500 text-white px-4 py-2 rounded">提交</button>
      </div>
      <div className="mt-3 text-sm text-gray-700">{msg}</div>
    </div>
  )
}

export default OrderCreatePage

